export interface SalatiStatusDto
{
    getClientTxnId(): string;
    getChannelId(): string;
    getServiceId(): string;
    getActivityId(): string;
    getAPartyMsisdn(): string;
    getLanguage(): string;

    getServiceName():string;
    getSalatiStatus():string;
}

export class SalatiStatusDtoImpl implements SalatiStatusDto
{
    private clientTxnId: string;
    private channelId: string;
    private serviceId: string;
    private activityId: string;
    private aPartyMsisdn: string;
    private language: string;
    private serviceName: string;
    private salatiStatus: string;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string 
    {
        return this.serviceId;
    } 

    setActivityId(activityId: string)
    {
        this.activityId = activityId;
    }
    getActivityId(): string 
    {
        return this.activityId;
    } 

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    } 

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }
    
    setServiceName(serviceName: string)
    {
        this.serviceName = serviceName;
    }
    getServiceName(): string 
    {
        return this.serviceName;
    }

    setSalatiStatus(salatiStatus: string)
    {
        this.salatiStatus = salatiStatus;
    }
    getSalatiStatus(): string 
    {
        return this.salatiStatus;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/salatistatus/salatistatusdto.ts